"use client";
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import * as React from 'react';
import { Icon } from '../../Icon/Icon.web.js';

var _excluded = ["color", "size"];
var IconChargingPole = function IconChargingPole(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === undefined ? 'currentColor' : _ref$color,
    _ref$size = _ref.size,
    sizeProp = _ref$size === undefined ? '48px' : _ref$size,
    props = _objectWithoutProperties(_ref, _excluded);
  var size = sizeProp;
  return /*#__PURE__*/React.createElement(Icon, props, /*#__PURE__*/React.createElement("svg", {
    fill: "none",
    viewBox: "0 0 48 48",
    width: size,
    height: size
  }, /*#__PURE__*/React.createElement("path", {
    fill: color,
    fillRule: "evenodd",
    d: "m36.697 6.527-1.414-1.414-1.855 1.855-1.502-1.502-2.524 2.524a5 5 0 0 0-.423 6.59 4.64 4.64 0 0 0 .445 5.63l.169.176 4.14 4.141-.01.01.114.125a1.91 1.91 0 0 1-.113 2.58 1.91 1.91 0 0 1-2.707 0l-5.92-5.92-.097.098V16l-.005-.217A5 5 0 0 0 20 11h-6l-.217.005A5 5 0 0 0 9 16v27h2V16l.005-.176A3 3 0 0 1 14 13h6l.176.005A3 3 0 0 1 23 16v27h2V24.054l4.603 4.603.16.152a3.91 3.91 0 0 0 5.375-.153 3.91 3.91 0 0 0 .15-5.373l-.152-.16.011-.01-4.14-4.14-.142-.154a2.64 2.64 0 0 1-.342-2.918 5 5 0 0 0 5.949-.84l2.525-2.524-1.4-1.4 1.82-1.82-1.414-1.414-1.82 1.82-1.34-1.341zm-.529 6.01-4.242-4.242-1.11 1.109a3 3 0 0 0-.02 4.224l.14.133a3 3 0 0 0 4.122-.114zM14.29 27.66l3.61-7.21v5.41h1.8l-3.61 7.21v-5.41z",
    clipRule: "evenodd"
  })));
};

export { IconChargingPole, IconChargingPole as default };
